import { LinkEntityMapper } from '~/passporter-services/link/entityMapper'
import { ProfileEntityMapper } from '~/passporter-services/profile/entityMapper'
import {
	ApiWallPin,
	ApiTextWallPin,
	ApiLinkWallPin,
	API_WALL_PIN_TYPE,
	ApiMediaWallPin,
} from './apiTypes'
import { WallPin, TextWallPin, LinkWallPin, WALL_PIN_TYPE, MediaWallPin } from '~/models/WallPin'
import { MediaEntityMapper } from '~/passporter-services/media/entityMapper'

export class WallPinEntityMapper {
	static toWallPins(apiWallPins: ApiWallPin[]): WallPin[] {
		return apiWallPins
			.map((apiWallPin) => this.toWallPin(apiWallPin))
			.filter((pin) => pin !== undefined)
	}

	static toWallPin(apiWallPin: ApiWallPin): WallPin | undefined {
		const wallPinMappers: Record<API_WALL_PIN_TYPE, (wallpin: ApiWallPin) => WallPin | undefined> =
			{
				[API_WALL_PIN_TYPE.TEXT]: (apiWallPin: ApiWallPin) =>
					this.mapText(apiWallPin as ApiTextWallPin),
				[API_WALL_PIN_TYPE.LINK]: (apiWallPin: ApiWallPin) =>
					this.mapLink(apiWallPin as ApiLinkWallPin),
				[API_WALL_PIN_TYPE.MEDIA]: (apiWallPin: ApiWallPin) =>
					this.mapMedia(apiWallPin as ApiMediaWallPin),
			}
		if (!wallPinMappers[apiWallPin.type]) return
		return wallPinMappers[apiWallPin.type](apiWallPin)
	}

	private static mapText(apiPin: ApiTextWallPin): TextWallPin {
		const wallPin: TextWallPin = {
			id: apiPin.id,
			type: WALL_PIN_TYPE.TEXT,
			created: apiPin.created,
			data: {
				time: apiPin.data.time,
				version: apiPin.data.version,
				blocks: apiPin.data.blocks,
			},
		}
		if (apiPin.owner) wallPin.owner = ProfileEntityMapper.toProfile(apiPin.owner)
		return wallPin
	}

	private static mapLink(apiPin: ApiLinkWallPin): LinkWallPin {
		const wallPin: LinkWallPin = {
			id: apiPin.id,
			type: WALL_PIN_TYPE.LINK,
			created: apiPin.created,
			data: LinkEntityMapper.toLink(apiPin.data),
		}
		if (apiPin.owner) wallPin.owner = ProfileEntityMapper.toProfile(apiPin.owner)
		return wallPin
	}

	private static mapMedia(apiPin: ApiMediaWallPin): MediaWallPin | undefined {
		if (!apiPin.data.media) return undefined
		const wallPin: MediaWallPin = {
			id: apiPin.id,
			type: WALL_PIN_TYPE.MEDIA,
			created: apiPin.created,
			data: MediaEntityMapper.toMedia(apiPin.data.media),
		}
		if (apiPin.owner) wallPin.owner = ProfileEntityMapper.toProfile(apiPin.owner)
		return wallPin
	}
}
